import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { RouletteApi } from '../../../Utils/Api/RouletteApi';
import { cdnUrlConfig } from '../../../Utils/atoms';
import { useAlert } from 'react-alert';

const GifticonPopUp = (props) => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;
	const [phoneNo, setPhoneNo] = useState('');
	const [gifticons, setGifticons] = useState({}); // 기프티콘 내역
	const alert = useAlert();

	// 전화번호 저장 클릭
	const onClickSavePhoneNumber = () => {
		const phoneNumberCheckRegex = /01[016789][^0][0-9]{2,3}[0-9]{3,4}/;

		if (phoneNo == '') {
			props.close();
		} else if (!phoneNumberCheckRegex.test(phoneNo)) {
			alert.info('올바르지 않은 번호입니다.');
		} else {
			const data = {
				member_se: props.memberSe,
				phone_no: phoneNo,
			};
			RouletteApi.PatchSavePhoneNumber(data).then((response) => {
				const { status } = response;
				if (status === 201) {
					alert.info('성공적으로 저장되었습니다.');
					props.close();
				}
			});
		}
	};

	// GET 기프티콘 당첨 내역
	useEffect(() => {
		RouletteApi.GetRouletteGifticons(props.eventSe, props.memberSe).then(
			(response) => {
				const { status, data } = response;
				if (status === 200) {
					setGifticons(data.datas);
				}
			}
		);
	}, []);

	// 객체에서 각 기프티콘의 당첨된 개수 반환
	const getGifticonRewardCount = (rank_no) => {
		for (var i = 0; i < gifticons.length; i++) {
			if (gifticons[i].rank_no === rank_no) {
				return gifticons[i].event_gifticon_reward_cn;
			}
		}
	};

	// GET 휴대전화번호
	useEffect(() => {
		RouletteApi.GetRoulettePhoneNumber(props.memberSe).then((response) => {
			const { status, data } = response;
			if (status === 200) {
				setPhoneNo(data.phoneNumber);
			}
		});
	}, []);

	return (
		<>
			{/* 당첨리스트 팝업(당첨 리스트 보기) */}
			<div className='dim'></div>
			<div className={'popup pop-prize'}>
				<header>
					<h1>
						<span>당첨 리스트 보기</span>
					</h1>
				</header>
				<div className='content'>
					<div className='reward'>
						<div className="count">{getGifticonRewardCount(1)}개</div>
						<div className='photo'>
							<figure>
								<img
									src={`${IMG_URL}/images/roulette/product_1.png`}
									alt="올리브영 기프트카드"
								/>
							</figure>
							<figcaption>올리브영 기프트카드</figcaption>
						</div>
						<div className='name'>50,000원 권</div>
					</div>
					<div className='reward'>
						<div className="count">{getGifticonRewardCount(2)}개</div>
						<div className='photo'>
							<figure>
								<img
									src={`${IMG_URL}/images/roulette/product_2.png`}
									alt="CU 모바일 금액권"
								/>
							</figure>
							<figcaption>CU 모바일 금액권</figcaption>
						</div>
						<div className='name'>5,000원 권</div>
					</div>
					<div className='reward'>
						<div className="count">{getGifticonRewardCount(3)}개</div>
						<div className='photo'>
							<figure>
								<img
									src={`${IMG_URL}/images/roulette/product_3.png`}
									alt="다이소 모바일 금액권"
								/>
							</figure>
							<figcaption>다이소 모바일 금액권</figcaption>
						</div>
						<div className='name'>3,000원 권</div>
					</div>
				</div>
				<div className='ipt-area'>
					<input
						type='text'
						value={phoneNo}
						placeholder='휴대전화번호를 -없이 입력해주세요.'
						onChange={(e) => setPhoneNo(e.target.value)}
					/>
					<p>전화번호를 입력하지 않으면 기프티콘 선물을 받을 수 없습니다.</p>
				</div>
				<div className='btn-area'>
					<div className='btn-confirm' onClick={onClickSavePhoneNumber}>
						완료
					</div>
				</div>
			</div>
		</>
	);
};

export default GifticonPopUp;
